import React from 'react';
import { DeviceContext } from './DeviceContext';
export function withDevice(Component) {
  // Extract the Consumer from Context
  var Consumer = DeviceContext.Consumer;
  return function (props) {
    return /*#__PURE__*/React.createElement(Consumer, null, function (device) {
      return /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
        device: device
      }));
    });
  };
}
;